export default {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      display: 'flex',
      flexDirection: 'column',
      background: v.backgroundColor
    };
  }
};